import { COURSE } from "./course";

// tier = plan d'accès requis (Débutant / Expert / Premium)
// level = niveau de difficulté (Débutant / Intermédiaire / Expert)
export const FORMATIONS = [
  {
    id: "intro-ia", title: "Introduction à l'IA", tier: "Débutant", level: "Débutant",
    lessons: 8, minutes: 45,
    desc: "Les fondamentaux de l'intelligence artificielle pour bien démarrer.",
    chapters: ["Qu'est-ce que l'IA ?", "Histoire et évolution", "Machine learning vs deep learning",
      "Les LLM expliqués simplement", "Cas d'usage business", "Outils IA essentiels",
      "Éthique, limites et défauts des outils IA", "Votre premier projet IA"],
  },
  {
    id: "chatgpt-mastery", title: "ChatGPT Mastery", tier: "Débutant", level: "Débutant",
    lessons: COURSE.lessons.length, minutes: COURSE.totalMinutes,
    desc: "Maîtrisez ChatGPT et le prompt engineering de A à Z.", course: COURSE,
  },
  {
    id: "auto-marketing", title: "Automatisation Marketing IA", tier: "Expert", level: "Intermédiaire",
    lessons: 15, minutes: 90,
    desc: "Automatisez votre marketing avec des agents IA.",
    chapters: ["Cartographier ses workflows", "Email automation", "Contenu automatique",
      "Publicités générées par IA", "CRM & lead scoring", "Tableaux de bord analytics", "Intégrations no-code"],
  },
  {
    id: "prompt-avance", title: "Prompt Engineering Avancé", tier: "Expert", level: "Expert",
    lessons: 18, minutes: 150,
    desc: "Techniques avancées de prompt engineering.",
    chapters: ["Chaînage de prompts", "Few-shot & Chain-of-Thought", "Prompts système", "RAG",
      "Agents & appels d'outils", "Évaluation des sorties", "Optimisation des coûts"],
  },
  {
    id: "business-ia", title: "Business IA Rentable", tier: "Premium", level: "Intermédiaire",
    lessons: 20, minutes: 120,
    desc: "Construisez un business rentable propulsé par l'IA.",
    chapters: ["Choisir un modèle rentable", "Étude de marché IA", "Créer une offre irrésistible",
      "Acquisition automatisée", "Tunnel de vente IA", "Pricing & marges", "Scaling", "Études de cas"],
  },
  {
    id: "agence-ia", title: "Agence IA Premium", tier: "Premium", level: "Expert",
    lessons: 25, minutes: 180,
    desc: "Lancez et scalez une agence de services IA.",
    chapters: ["Positionnement", "Construire ses offres", "Prospection IA", "Délivrer avec l'IA",
      "Recrutement", "Process & SOP", "Facturation", "Croissance"],
  },
  {
    id: "perso-faceless", title: "Personnage IA faceless", tier: "Premium", level: "Intermédiaire",
    lessons: 12, minutes: 90,
    desc: "Créez un personnage IA faceless pour vos contenus.",
    chapters: ["Le concept faceless", "Créer l'avatar (clone IA)", "Voix IA", "Scripts viraux",
      "Montage automatique", "Publier sur les réseaux", "Monétisation"],
  },
  {
    id: "monetiser-perso", title: "Monétiser son personnage IA", tier: "Premium", level: "Expert",
    lessons: 15, minutes: 110,
    desc: "Transformez votre personnage IA en source de revenus.",
    chapters: ["Modèles de revenus", "Sponsoring", "Produits digitaux", "Affiliation",
      "Formations", "Communauté payante", "Scaling multi-plateformes"],
  },
];

export const TIER_TABS = ["Tous", "Débutant", "Expert", "Premium"];

export const TIER_STYLES = {
  "Débutant": "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  "Expert": "border-blue-400/40 bg-blue-400/10 text-blue-300",
  "Premium": "border-amber-400/40 bg-amber-400/10 text-amber-300",
};
